export const VARIABLE_REGEX = /\{\{\s([\d.]+[a-zA-Z.]+)\s\}\}/g;

export const getQuestionIdFromVariable = (value: string) => {
  const regex = /\{\{\s([a-zA-Z0-9_]+)\.[a-zA-Z.]*\s\}\}/;
  const match = value?.match(regex);

  if (match && match?.length >= 2) {
    return match[1];
  }
};
